import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Ng4FilesStatus, Ng4FilesSelected, Ng4FilesConfig, Ng4FilesService } from 'angular4-files-upload';
import { environment } from 'environments/environment';
import * as Models from 'app/core/models';
import { ProcessService } from 'app/core/process/process.service';
import { ModalService } from 'app/modal/modal.service';
import { ToastService, TabsetComponent } from 'libs/mdbootstrap/typescripts/pro';

@Component({
  selector: 'app-media-upload-modal',
  templateUrl: './mediaUploadModal.component.html',
  styleUrls: ['./mediaUploadModal.component.scss']
})

export class MediaUploadModalComponent implements OnInit, Models.ModalComponent {

  @ViewChild('modalMediaUpload') public contentModal: any;
  @ViewChild('mediaTypeTabs') public mediaTypeTabs: TabsetComponent;

  version: string = environment.version;
  error: any = null;
  mode: Models.MediaModalModes = Models.MediaModalModes.IMAGE_AND_VIDEO;
  isLoading = false;
  showSuccessMessage = false;
  processId: number;
  showVideo = false;
  showImage = true;
  showError = false;
  videoUrl = '';
  startTime: number;
  endTime: number;
  start: string;
  end: string;
  medias: Array<Models.Media> = [];
  uploadedMedia: Models.Media;
  inputMediaId: string;
  inputMedia: Models.Media;
  MediaModalModes = Models.MediaModalModes;
  timeRegexPatternZeroToFive: RegExp = /^[0-5]$/;
  timeRegexPatternZeroToNine: RegExp = /^[0-9]$/;
  timeMaskRegexPattern: any = { 'a': { pattern: new RegExp(this.timeRegexPatternZeroToFive) },
    'b': { pattern: new RegExp(this.timeRegexPatternZeroToNine) } };

  private videoId: string;
  private videoIframeUrl: SafeResourceUrl;
  private videoUrlInputTouched: boolean;

  public selectedFiles: any;
  private acceptedImageExtensions: Array<string> = ['jpg', 'jpeg', 'png', 'gif'];

  private configImage: Ng4FilesConfig = {
    acceptExtensions: [],
    maxFilesCount: 1
  };

  constructor(private router: Router,
              private processService: ProcessService,
              private ng4FilesService: Ng4FilesService,
              private modalService: ModalService,
              private domSanitizer: DomSanitizer,
              private toastrService: ToastService) {

  }

  ngOnInit() {
    this.ng4FilesService.addConfig(this.configImage, 'upload-image-config');
  }

  reset() {
    this.showSuccessMessage = false;
    this.showVideo = false;
    this.showImage = true;
    this.videoUrl = null;
    this.startTime = null;
    this.endTime = null;
    this.start = null;
    this.end = null;
    this.inputMediaId = null;
    this.videoUrlInputTouched = false;
  }

  get errorMessage(): string {
    if (this.error) {
      const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
      if (errorBody && errorBody.error) {
        return errorBody.error;
      }
    }
    // @TODO: translate
    return 'There was a problem.';
  }

  openModal(args: any[]) {
    this.processId = args[0];
    this.medias = args[1];
    this.mode = <Models.MediaModalModes>args[2];
    this.reset();

    this.inputMedia = args[3];

    if (this.inputMedia) {
      this.inputMediaId = this.inputMedia.mediaId;

      if (this.inputMedia.mediaType === Models.MediaType.youtubeVideo) {
        this.videoUrl = this.inputMedia.mediaUrl;
        this.start = this.inputMedia.startTime ? this.convertSecondsToHHMMSS(this.inputMedia.startTime) : null;
        this.end = this.inputMedia.endTime ? this.convertSecondsToHHMMSS(this.inputMedia.endTime) : null;
        this.mediaTypeTabs.setActiveTab(2);
        this.videoId = this.getVideoId(this.videoUrl);
        this.videoIframeUrl = this.getVideoIframeUrl();

      } else if (this.inputMedia.mediaType === Models.MediaType.image) {
        this.mediaTypeTabs.setActiveTab(1);
      }
    }
    this.contentModal.show();
  }

  closeModal() {
    this.contentModal.hide();
  }

  public filesSelect(selectedFiles: Ng4FilesSelected): void {
    if (selectedFiles.status !== Ng4FilesStatus.STATUS_SUCCESS) {
      this.selectedFiles = selectedFiles.status;
      return;
    }

    // Handle error statuses here
    this.selectedFiles = Array.from(selectedFiles.files).map(file => file.name);
    const file: File = selectedFiles.files[0];

    const re = /(?:\.([^.]+))?$/;
    const ext = re.exec(file.name)[1];

    if (!ext || this.acceptedImageExtensions.indexOf(ext.toLowerCase()) === -1) {
      selectedFiles.files = [];
      // @TODO: translate
      this.toastrService.error('Please choose an image(png, jpg, jpeg).');
      return;
    }

    const formData = new FormData();
    formData.append('type', '1');
    formData.append('processId', this.processId.toString());
    formData.append('file', file);
    this.uploadMedia(formData);
  }

  uploadMedia(formData: FormData) {
    this.isLoading = true;
    this.processService.uploadMedia(formData)
      .finally(() => {
        this.isLoading = false;
      })
      .subscribe(media => {
        this.uploadedMedia = media;
        if (this.medias.findIndex(x => x.mediaUrl === media.mediaUrl) < 0) {
          // skipping the videos if one with the same url already exists
          this.medias.push(media);
        }
        this.error = null;
        this.showError = false;
        const resultData: Models.ModalResult = { modalType: Models.ModalType.MEDIA_UPLOAD, result: media };
        this.modalService.returnEvent(resultData);
      }, error => {
        this.error = error;
        this.showError = true;
      });
  }

  get images(): Array<Models.Media> {
    return this.medias.filter(x => x.mediaType === 1);
  }

  get videoes(): Array<Models.Media> {
    return this.medias.filter(x => x.mediaType === 2);
  }

  change($event: Event, src?: string) {
    if (src === 'urlInput') {
      this.inputMedia = null;
      this.inputMediaId = null;
    }
    this.videoId = this.getVideoId(this.videoUrl);
    this.startTime = this.getSecondsFromString(this.start);
    this.endTime = this.getSecondsFromString(this.end);

    if (this.videoId) {
      this.videoIframeUrl = this.getVideoIframeUrl();
    }
  }

  getVideoId(url: string): string {
    if (!url) {
      return null;
    }
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : null;
  }


  isVideoValid() {
    return this.videoUrl && this.getVideoId(this.videoUrl);
  }

  getVideoThumbnail(video: Models.Media): string {
    if (!video.mediaUrl) {
      return '';
    }
    const videoId: string = this.getVideoId(video.mediaUrl);
    if (!videoId) {
      return '';
    }
    return 'https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg';
  }

  saveVideo() {
    if (!this.videoUrl) {
      return;
    }
    const formData = new FormData();
    formData.append('type', '2');
    formData.append('processId', this.processId.toString());
    formData.append('file', null);
    formData.append('origibalUrl', this.videoUrl);
    formData.append('startTime', this.startTime ? this.startTime.toString() : null);
    formData.append('endTime', this.endTime ? this.endTime.toString() : null);
    this.uploadMedia(formData);
  }

  selectImage(media: Models.Media) {
    const resultData: Models.ModalResult = { modalType: Models.ModalType.MEDIA_UPLOAD, result: media };
    this.modalService.returnEvent(resultData);
  }

  selectVideo(media: Models.Media) {
    this.videoUrl = media.mediaUrl;

    if (media.startTime) {
      this.start = this.convertSecondsToHHMMSS(media.startTime);
    }

    if (media.endTime) {
      this.start = this.convertSecondsToHHMMSS(media.endTime);
    }

    this.change(null);
  }

  cancel() {
    const resultData: Models.ModalResult = { modalType: Models.ModalType.MEDIA_UPLOAD, result: null };
    this.modalService.returnEvent(resultData);
  }

  getVideoIframeUrl() {
    const domain = 'https://www.youtube.com/embed/' + this.videoId + '?';
    const qs = (this.endTime ? 'end=' + this.endTime : '') + '&rel=0&start=' + (this.startTime ? this.startTime : 0) + '&iv_load_policy=3';
    return this.videoId ? this.domSanitizer.bypassSecurityTrustResourceUrl(domain + qs) : null;
  }

  setVideoUrlInputTouched(){
    this.videoUrlInputTouched = true;
  }

  private getSecondsFromString(str: string): number {
    if (!str) {
      return null;
    }
    const p: string[] = str.split(':');
    let s = 0, m = 1;

    while (p.length > 0) {
      s += m * parseInt(p.pop(), 10);
      m *= 60;
    }

    return s;
  }

  private convertSecondsToHHMMSS(seconds: number): string {
    const date = new Date(null);
    date.setSeconds(seconds);
    return date.toISOString().substr(11, 8);
  }

}




// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/mediaUploadModal/mediaUploadModal.component.ts